'use strict';

/*------------------------------------*\
 * JS Main entry file
 \*------------------------------------*/
import './config';

// Import utilities.
// import galleryInit from '@utilities/gallery-init';

// Import Singletons
// import '@utilities/tns';
import '@utilities/detect-touch';
import initSliders from '@utilities/slider';
// import '@components/Navigation';

// Import modules.
import Navigation from '@components/navigation';

// Initialize modules.
// galleryInit('[js-hook-gallery]', Gallery);

Navigation();
initSliders();



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/dudok.test/frontend/source/javascript/main.js